export default "/images/home-icon.png?133bc2a456a4d8dba37c3edf96da3acf";